<section class="mb-30">
  <app-reports-card [reportsData]="taxReportsData"></app-reports-card>
</section>

<app-report-not-found></app-report-not-found>
